import React from 'react';
import { Trash2, AlertTriangle, RefreshCw } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Button } from '../../components/ui/button';

const DataCleanupCard = ({ onCleanup, executing }) => {
  return (
    <Card className="glass-card border-white/20">
      <CardHeader>
        <div className="flex items-center gap-2">
          <Trash2 className="w-5 h-5 text-destructive" />
          <div>
            <CardTitle>Data Cleanup</CardTitle>
            <CardDescription className="mt-1">Remove test/seed data</CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="p-3 rounded-lg bg-warning/5 border border-warning/20">
          <div className="flex items-start gap-2">
            <AlertTriangle className="w-4 h-4 text-warning mt-0.5 flex-shrink-0" />
            <p className="text-xs text-muted-foreground">
              This will delete leads with test/demo names, test emails, and old test calls. Always run dry-run first!
            </p>
          </div>
        </div>

        <div className="flex gap-2">
          <Button
            onClick={() => onCleanup(true)}
            disabled={executing === 'cleanup-dry'}
            variant="outline"
            className="flex-1 gap-2"
            data-testid="cleanup-dryrun-btn"
          >
            {executing === 'cleanup-dry' ? (
              <><RefreshCw className="w-4 h-4 animate-spin" /> Running...</>
            ) : (
              <>Dry Run</>
            )}
          </Button>

          <Button
            onClick={() => onCleanup(false)}
            disabled={executing === 'cleanup-live'}
            variant="destructive"
            className="flex-1 gap-2"
            data-testid="cleanup-live-btn"
          >
            {executing === 'cleanup-live' ? (
              <><RefreshCw className="w-4 h-4 animate-spin" /> Deleting...</>
            ) : (
              <>Live Cleanup</>
            )}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default DataCleanupCard;
